var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor table-find-record" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("section", [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.findRecordTabloSe"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-selection-row" },
          [
            _c("CustomPicker", {
              attrs: {
                items: _vm.tables,
                idKey: "_id",
                labelKey: "name",
                title: "Tablo Seç",
              },
              on: { change: _vm.onTableChange },
              model: {
                value: _vm.clone.tableId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "tableId", $$v)
                },
                expression: "clone.tableId",
              },
            }),
            _vm._v(" "),
            _vm.clone.tableId
              ? _c(
                  "SupsisButton",
                  {
                    staticClass: "go-to-table-btn",
                    attrs: { ghost: "" },
                    on: { click: _vm.goToTable },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("visibility"),
                    ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("auto.findRecordTabloyaGit")) +
                        "\n                "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.getSelectedTable()
        ? _c("section", [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("auto.findRecordFiltreler"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-actions" },
              [
                _c(
                  "a-button",
                  {
                    attrs: { type: "dashed", icon: "plus" },
                    on: { click: _vm.addFilter },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("auto.findRecordKoUlEkle")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-conditions" },
              _vm._l(_vm.clone.filters, function (filter, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "filter-row" },
                  [
                    _c("CustomPicker", {
                      staticStyle: { width: "20%", "margin-right": "8px" },
                      attrs: {
                        items: _vm.getFields(),
                        idKey: "_id",
                        labelKey: "name",
                        title: "Alan",
                        icon: _vm.getFieldIcon(filter.fieldId),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.onFieldChange(filter)
                        },
                      },
                      model: {
                        value: _vm.clone.filters[index].fieldId,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone.filters[index], "fieldId", $$v)
                        },
                        expression: "clone.filters[index].fieldId",
                      },
                    }),
                    _vm._v(" "),
                    _c("CustomPicker", {
                      staticStyle: { width: "15%", "margin-right": "8px" },
                      attrs: {
                        items: _vm.getOperators(filter),
                        idKey: "value",
                        labelKey: "label",
                        title: "Operatör",
                        icon: "filter_list",
                        disabled: !filter.fieldId,
                      },
                      model: {
                        value: _vm.clone.filters[index].operator,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone.filters[index], "operator", $$v)
                        },
                        expression: "clone.filters[index].operator",
                      },
                    }),
                    _vm._v(" "),
                    ["checkbox", "dropdown"].includes(
                      _vm.getFieldType(filter.fieldId)
                    )
                      ? _c(
                          "div",
                          { staticClass: "mode-switch" },
                          [
                            _c(
                              "a-tooltip",
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "auto.findRecordStatikModNcedenTanMlanmDeErleriKullanR"
                                                )
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                                Dinamik mod: Değişkenleri veya kullanıcı girdilerini kullanır\n                            "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "a-switch",
                                  {
                                    attrs: {
                                      checked: filter.mode === "static",
                                      size: "small",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onModeChange(index, $event)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "checkedChildren" },
                                        slot: "checkedChildren",
                                      },
                                      [_vm._v("Statik")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "unCheckedChildren" },
                                        slot: "unCheckedChildren",
                                      },
                                      [_vm._v("Dinamik")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    filter.mode === "static"
                      ? _c(_vm.getValueInputComponent(filter), {
                          tag: "component",
                          staticStyle: { width: "30%", "margin-right": "8px" },
                          attrs: {
                            options: _vm.getFieldOptions(filter),
                            placeholder: "Değer",
                            disabled: !filter.operator,
                          },
                          model: {
                            value: _vm.clone.filters[index].value,
                            callback: function ($$v) {
                              _vm.$set(_vm.clone.filters[index], "value", $$v)
                            },
                            expression: "clone.filters[index].value",
                          },
                        })
                      : _c(
                          "div",
                          { staticClass: "text-editor-wrapper" },
                          [
                            _c("TiptapEditor", {
                              attrs: {
                                placeholder: "Değer",
                                "show-attributes": true,
                                "show-emoji": true,
                                "max-character-count": 1024,
                                "automation-mode": "",
                              },
                              model: {
                                value: _vm.clone.filters[index].value,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.clone.filters[index],
                                    "value",
                                    $$v
                                  )
                                },
                                expression: "clone.filters[index].value",
                              },
                            }),
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _c("a-button", {
                      attrs: { type: "danger", icon: "delete" },
                      on: {
                        click: function ($event) {
                          return _vm.removeFilter(index)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.getSelectedTable()
        ? _c("section", { staticClass: "mt-1" }, [
            _c("div", { staticClass: "filter-advanced-options" }, [
              _c(
                "div",
                { staticClass: "option-item" },
                [
                  _c("div", { staticClass: "option-label" }, [
                    _vm._v("Basitleştirilmiş Veri Formatı"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "option-description" }, [
                    _vm._v(
                      "\n                        Bu mod açıkken API daha basit bir JSON formatında veri döndürür\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-switch",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.clone.minimizedDataFormat,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "minimizedDataFormat", $$v)
                        },
                        expression: "clone.minimizedDataFormat",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          attrs: { slot: "checkedChildren" },
                          slot: "checkedChildren",
                        },
                        [_vm._v("Açık")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          attrs: { slot: "unCheckedChildren" },
                          slot: "unCheckedChildren",
                        },
                        [_vm._v("Kapalı")]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }